import { defineMessage } from 'services/localization';

export const messages = {
    headerText: defineMessage('contact_person'),
    accountNumber: defineMessage('account_number'),
    primaryPerson: defineMessage('primary_person'),
    primaryPersonEmail: defineMessage('primary_person_email'),
    anotherPerson: defineMessage('another_person_index'),
    anotherPersonEmail: defineMessage('another_person_index_email'),
};
